export const ERROR_MESSAGES = {
    ATTEST: 'selfDesignation.validation_error_message.attest',
    DOCUMENT_TYPE: 'selfDesignation.validation_error_message.documentType',
    DOCUMENT_NUMBER: 'selfDesignation.validation_error_message.documentNumber',
    METHOD: 'selfDesignation.validation_error_message.method',
    SSN: 'selfDesignation.validation_error_message.ssn',
    DOB: 'selfDesignation.validation_error_message.dob',
    DOB_GREATER_THAN_CURRENT_DATE: 'selfDesignation.validation_error_message.dobGreaterThanCurrentDate',
    ZIP_CODE: 'selfDesignation.validation_error_message.zipCode',
    FIRST_NAME: 'selfDesignation.validation_error_message.firstName',
    LAST_NAME: 'selfDesignation.validation_error_message.lastName',
    EMAIL: 'selfDesignation.validation_error_message.email',
    CITY: 'selfDesignation.validation_error_message.city',
    NOT_EMPTY: 'selfDesignation.validation_error_message.notEmpty',
};

export const ALL_DOCUMENT_TYPES = {
    CERTIFICATE_OF_NATURALIZATION: 'Certificate of Naturalization',
    CERTIFICATE_OF_NATURALIZATION_FROM_N_55:
        'Certificate of Naturalization (Form N-550 or N-570) or US Citizenship (Form N-560 or N-561)',
    DIVORCE_DECREE: 'Divorce Decree',
    DRIVER_LICENSE: 'Driver\'s License issued by state or territory',
    EMPLOYER_IDENTIFICATION_CARD: 'Employer Identification Card',
    EMPLOYMENT_AUTHORIZATION_DOCUMENT: 'Employment Authorization Document that contains a photograph (Form I-766)',
    FOREIGN_PASSPORT: 'Foreign passport or ID issued by a foreign embassy or consulate contains a photograph',
    DIPLOMA: 'High School or College diploma (including high school equivalency diplomas)',
    IDENTIFICATION_CARD: 'Identification Card Issued by the Federal, State or Local Government',
    MARRIAGE_CERTIFICATE: 'Marriage Certificate',
    MILITARY_DEPENDANT_ID_CARD: 'Military dependent\'s identification card',
    NATIVE_AMERICAN_TRIBAL_DOCUMENT: 'Native American Tribal document',
    PERMANENT_RESIDENT_CARD: 'Permanent Resident Card or Alien Registration Receipt Card (Form I-551)',
    PROPERTY_DEED_OR_TITLE: 'Property Deed or Title',
    SCHOOL_ID_CARD: 'School identification card',
    SSN: 'Social Security Card',
    US_COAST_GUARD_MARINER_CARD: 'U.S Coast Guard Merchant Mariner card',
    BIRTH_RECORD: 'U.S.Public Birth Record',
    MILITARY_CARD: 'U.S military card or draft record',
    PASSPORT: 'U.S passport or U.S passport card',
    VOTER_REGISTRATION_CARD: 'Voter registration card',
};

export const DOCUMENT_TYPES = {
    GA: {
        CERTIFICATE_OF_NATURALIZATION: 'Certificate of Naturalization',
        CERTIFICATE_OF_NATURALIZATION_FROM_N_55:
            'Certificate of Naturalization (Form N-550 or N-570) or US Citizenship (Form N-560 or N-561)',
        DIVORCE_DECREE: 'Divorce Decree',
        DRIVER_LICENSE: 'Driver\'s License issued by state or territory',
        EMPLOYER_IDENTIFICATION_CARD: 'Employer Identification Card',
        EMPLOYMENT_AUTHORIZATION_DOCUMENT: 'Employment Authorization Document that contains a photograph (Form I-766)',
        FOREIGN_PASSPORT: 'Foreign passport or ID issued by a foreign embassy or consulate contains a photograph',
        DIPLOMA: 'High School or College diploma (including high school equivalency diplomas)',
        IDENTIFICATION_CARD: 'Identification Card Issued by the Federal, State or Local Government',
        MARRIAGE_CERTIFICATE: 'Marriage Certificate',
        MILITARY_DEPENDANT_ID_CARD: 'Military dependent\'s identification card',
        NATIVE_AMERICAN_TRIBAL_DOCUMENT: 'Native American Tribal document',
        PERMANENT_RESIDENT_CARD: 'Permanent Resident Card or Alien Registration Receipt Card (Form I-551)',
        PROPERTY_DEED_OR_TITLE: 'Property Deed or Title',
        SCHOOL_ID_CARD: 'School identification card',
        SSN: 'Social Security Card',
        US_COAST_GUARD_MARINER_CARD: 'U.S Coast Guard Merchant Mariner card',
        BIRTH_RECORD: 'U.S.Public Birth Record',
        MILITARY_CARD: 'U.S military card or draft record',
        PASSPORT: 'U.S passport or U.S passport card',
        VOTER_REGISTRATION_CARD: 'Voter registration card',
    },
    NJ: {
        CERTIFICATE_OF_NATURALIZATION: 'Certificate of Naturalization',
        CERTIFICATE_OF_NATURALIZATION_FROM_N_55:
            'Certificate of Naturalization (Form N-550 or N-570) or US Citizenship (Form N-560 or N-561)',
        DRIVER_LICENSE: 'Driver\'s License issued by state or territory',
        EMPLOYER_IDENTIFICATION_CARD: 'Employer Identification Card',
        EMPLOYMENT_AUTHORIZATION_DOCUMENT: 'Employment Authorization Document that contains a photograph (Form I-766)',
        FOREIGN_PASSPORT: 'Foreign passport or ID issued by a foreign embassy or consulate contains a photograph',
        IDENTIFICATION_CARD: 'Identification Card Issued by the Federal, State or Local Government',
        MILITARY_DEPENDANT_ID_CARD: 'Military dependent\'s identification card',
        NATIVE_AMERICAN_TRIBAL_DOCUMENT: 'Native American Tribal document',
        PERMANENT_RESIDENT_CARD: 'Permanent Resident Card or Alien Registration Receipt Card (Form I-551)',
        SCHOOL_ID_CARD: 'School identification card',
        SSN: 'Social Security Card',
        US_COAST_GUARD_MARINER_CARD: 'U.S Coast Guard Merchant Mariner card',
        MILITARY_CARD: 'U.S military card or draft record',
        PASSPORT: 'U.S passport or U.S passport card',
    },
    PA: {
        CERTIFICATE_OF_NATURALIZATION: 'Certificate of Naturalization',
        CERTIFICATE_OF_NATURALIZATION_FROM_N_55:
            'Certificate of Naturalization (Form N-550 or N-570) or US Citizenship (Form N-560 or N-561)',
        DIVORCE_DECREE: 'Divorce Decree',
        DRIVER_LICENSE: 'Driver\'s License issued by state or territory',
        EMPLOYER_IDENTIFICATION_CARD: 'Employer Identification Card',
        EMPLOYMENT_AUTHORIZATION_DOCUMENT: 'Employment Authorization Document that contains a photograph (Form I-766)',
        FOREIGN_PASSPORT: 'Foreign passport or ID issued by a foreign embassy or consulate contains a photograph',
        DIPLOMA: 'High School or College diploma (including high school equivalency diplomas)',
        IDENTIFICATION_CARD: 'Identification Card Issued by the Federal, State or Local Government',
        MARRIAGE_CERTIFICATE: 'Marriage Certificate',
        MILITARY_DEPENDANT_ID_CARD: 'Military dependent\'s identification card',
        NATIVE_AMERICAN_TRIBAL_DOCUMENT: 'Native American Tribal document',
        PERMANENT_RESIDENT_CARD: 'Permanent Resident Card or Alien Registration Receipt Card (Form I-551)',
        PROPERTY_DEED_OR_TITLE: 'Property Deed or Title',
        SCHOOL_ID_CARD: 'School identification card',
        SSN: 'Social Security Card',
        US_COAST_GUARD_MARINER_CARD: 'U.S Coast Guard Merchant Mariner card',
        BIRTH_RECORD: 'U.S.Public Birth Record',
        MILITARY_CARD: 'U.S military card or draft record',
        PASSPORT: 'U.S passport or U.S passport card',
        VOTER_REGISTRATION_CARD: 'Voter registration card',
    },
    VA: {
        CERTIFICATE_OF_NATURALIZATION: 'Certificate of Naturalization',
        CERTIFICATE_OF_NATURALIZATION_FROM_N_55:
            'Certificate of Naturalization (Form N-550 or N-570) or US Citizenship (Form N-560 or N-561)',
        DIVORCE_DECREE: 'Divorce Decree',
        DRIVER_LICENSE: 'Driver\'s License issued by state or territory',
        EMPLOYER_IDENTIFICATION_CARD: 'Employer Identification Card',
        EMPLOYMENT_AUTHORIZATION_DOCUMENT: 'Employment Authorization Document that contains a photograph (Form I-766)',
        FOREIGN_PASSPORT: 'Foreign passport or ID issued by a foreign embassy or consulate contains a photograph',
        DIPLOMA: 'High School or College diploma (including high school equivalency diplomas)',
        IDENTIFICATION_CARD: 'Identification Card Issued by the Federal, State or Local Government',
        MARRIAGE_CERTIFICATE: 'Marriage Certificate',
        MILITARY_DEPENDANT_ID_CARD: 'Military dependent\'s identification card',
        NATIVE_AMERICAN_TRIBAL_DOCUMENT: 'Native American Tribal document',
        PERMANENT_RESIDENT_CARD: 'Permanent Resident Card or Alien Registration Receipt Card (Form I-551)',
        PROPERTY_DEED_OR_TITLE: 'Property Deed or Title',
        SCHOOL_ID_CARD: 'School identification card',
        SSN: 'Social Security Card',
        US_COAST_GUARD_MARINER_CARD: 'U.S Coast Guard Merchant Mariner card',
        BIRTH_RECORD: 'U.S.Public Birth Record',
        MILITARY_CARD: 'U.S military card or draft record',
        PASSPORT: 'U.S passport or U.S passport card',
        VOTER_REGISTRATION_CARD: 'Voter registration card',
    },
    NM: {
        CERTIFICATE_OF_NATURALIZATION: 'Certificate of Naturalization',
        CERTIFICATE_OF_NATURALIZATION_FROM_N_55:
            'Certificate of Naturalization (Form N-550 or N-570) or US Citizenship (Form N-560 or N-561)',
        DIVORCE_DECREE: 'Divorce Decree',
        DRIVER_LICENSE: 'Driver\'s License issued by state or territory',
        EMPLOYER_IDENTIFICATION_CARD: 'Employer Identification Card',
        EMPLOYMENT_AUTHORIZATION_DOCUMENT: 'Employment Authorization Document that contains a photograph (Form I-766)',
        FOREIGN_PASSPORT: 'Foreign passport or ID issued by a foreign embassy or consulate contains a photograph',
        DIPLOMA: 'High School or College diploma (including high school equivalency diplomas)',
        IDENTIFICATION_CARD: 'Identification Card Issued by the Federal, State or Local Government',
        MARRIAGE_CERTIFICATE: 'Marriage Certificate',
        MILITARY_DEPENDANT_ID_CARD: 'Military dependent\'s identification card',
        NATIVE_AMERICAN_TRIBAL_DOCUMENT: 'Native American Tribal document',
        PERMANENT_RESIDENT_CARD: 'Permanent Resident Card or Alien Registration Receipt Card (Form I-551)',
        PROPERTY_DEED_OR_TITLE: 'Property Deed or Title',
        SCHOOL_ID_CARD: 'School identification card',
        SSN: 'Social Security Card',
        US_COAST_GUARD_MARINER_CARD: 'U.S Coast Guard Merchant Mariner card',
        BIRTH_RECORD: 'U.S.Public Birth Record',
        MILITARY_CARD: 'U.S military card or draft record',
        PASSPORT: 'U.S passport or U.S passport card',
        VOTER_REGISTRATION_CARD: 'Voter registration card',
    },
    NV: {
        CERTIFICATE_OF_NATURALIZATION: 'Certificate of Naturalization',
        CERTIFICATE_OF_NATURALIZATION_FROM_N_55:
            'Certificate of Naturalization (Form N-550 or N-570) or US Citizenship (Form N-560 or N-561)',
        DIVORCE_DECREE: 'Divorce Decree',
        DRIVER_LICENSE: 'Driver\'s License issued by state or territory',
        EMPLOYER_IDENTIFICATION_CARD: 'Employer Identification Card',
        EMPLOYMENT_AUTHORIZATION_DOCUMENT: 'Employment Authorization Document that contains a photograph (Form I-766)',
        FOREIGN_PASSPORT: 'Foreign passport or ID issued by a foreign embassy or consulate contains a photograph',
        DIPLOMA: 'High School or College diploma (including high school equivalency diplomas)',
        IDENTIFICATION_CARD: 'Identification Card Issued by the Federal, State or Local Government',
        MARRIAGE_CERTIFICATE: 'Marriage Certificate',
        MILITARY_DEPENDANT_ID_CARD: 'Military dependent\'s identification card',
        NATIVE_AMERICAN_TRIBAL_DOCUMENT: 'Native American Tribal document',
        PERMANENT_RESIDENT_CARD: 'Permanent Resident Card or Alien Registration Receipt Card (Form I-551)',
        PROPERTY_DEED_OR_TITLE: 'Property Deed or Title',
        SCHOOL_ID_CARD: 'School identification card',
        SSN: 'Social Security Card',
        US_COAST_GUARD_MARINER_CARD: 'U.S Coast Guard Merchant Mariner card',
        BIRTH_RECORD: 'U.S.Public Birth Record',
        MILITARY_CARD: 'U.S military card or draft record',
        PASSPORT: 'U.S passport or U.S passport card',
        VOTER_REGISTRATION_CARD: 'Voter registration card',
    },
    IL: {
        CERTIFICATE_OF_NATURALIZATION: 'Certificate of Naturalization',
        CERTIFICATE_OF_NATURALIZATION_FROM_N_55:
            'Certificate of Naturalization (Form N-550 or N-570) or US Citizenship (Form N-560 or N-561)',
        DIVORCE_DECREE: 'Divorce Decree',
        DRIVER_LICENSE: 'Driver\'s License issued by state or territory',
        EMPLOYER_IDENTIFICATION_CARD: 'Employer Identification Card',
        EMPLOYMENT_AUTHORIZATION_DOCUMENT: 'Employment Authorization Document that contains a photograph (Form I-766)',
        FOREIGN_PASSPORT: 'Foreign passport or ID issued by a foreign embassy or consulate contains a photograph',
        DIPLOMA: 'High School or College diploma (including high school equivalency diplomas)',
        IDENTIFICATION_CARD: 'Identification Card Issued by the Federal, State or Local Government',
        MARRIAGE_CERTIFICATE: 'Marriage Certificate',
        MILITARY_DEPENDANT_ID_CARD: 'Military dependent\'s identification card',
        NATIVE_AMERICAN_TRIBAL_DOCUMENT: 'Native American Tribal document',
        PERMANENT_RESIDENT_CARD: 'Permanent Resident Card or Alien Registration Receipt Card (Form I-551)',
        PROPERTY_DEED_OR_TITLE: 'Property Deed or Title',
        SCHOOL_ID_CARD: 'School identification card',
        SSN: 'Social Security Card',
        US_COAST_GUARD_MARINER_CARD: 'U.S Coast Guard Merchant Mariner card',
        BIRTH_RECORD: 'U.S.Public Birth Record',
        MILITARY_CARD: 'U.S military card or draft record',
        PASSPORT: 'U.S passport or U.S passport card',
        VOTER_REGISTRATION_CARD: 'Voter registration card',
    },
    MN: {
        CERTIFICATE_OF_NATURALIZATION: 'Certificate of Naturalization',
        CERTIFICATE_OF_NATURALIZATION_FROM_N_55:
            'Certificate of Naturalization (Form N-550 or N-570) or US Citizenship (Form N-560 or N-561)',
        DIVORCE_DECREE: 'Divorce Decree',
        DRIVER_LICENSE: 'Driver\'s License issued by state or territory',
        EMPLOYER_IDENTIFICATION_CARD: 'Employer Identification Card',
        EMPLOYMENT_AUTHORIZATION_DOCUMENT: 'Employment Authorization Document that contains a photograph (Form I-766)',
        FOREIGN_PASSPORT: 'Foreign passport or ID issued by a foreign embassy or consulate contains a photograph',
        DIPLOMA: 'High School or College diploma (including high school equivalency diplomas)',
        IDENTIFICATION_CARD: 'Identification Card Issued by the Federal, State or Local Government',
        MARRIAGE_CERTIFICATE: 'Marriage Certificate',
        MILITARY_DEPENDANT_ID_CARD: 'Military dependent\'s identification card',
        NATIVE_AMERICAN_TRIBAL_DOCUMENT: 'Native American Tribal document',
        PERMANENT_RESIDENT_CARD: 'Permanent Resident Card or Alien Registration Receipt Card (Form I-551)',
        PROPERTY_DEED_OR_TITLE: 'Property Deed or Title',
        SCHOOL_ID_CARD: 'School identification card',
        SSN: 'Social Security Card',
        US_COAST_GUARD_MARINER_CARD: 'U.S Coast Guard Merchant Mariner card',
        BIRTH_RECORD: 'U.S.Public Birth Record',
        MILITARY_CARD: 'U.S military card or draft record',
        PASSPORT: 'U.S passport or U.S passport card',
        VOTER_REGISTRATION_CARD: 'Voter registration card',
    },
    ID: {
        CERTIFICATE_OF_NATURALIZATION: 'Certificate of Naturalization',
        CERTIFICATE_OF_NATURALIZATION_FROM_N_55:
            'Certificate of Naturalization (Form N-550 or N-570) or US Citizenship (Form N-560 or N-561)',
        DIVORCE_DECREE: 'Divorce Decree',
        DRIVER_LICENSE: 'Driver\'s License issued by state or territory',
        EMPLOYER_IDENTIFICATION_CARD: 'Employer Identification Card',
        EMPLOYMENT_AUTHORIZATION_DOCUMENT: 'Employment Authorization Document that contains a photograph (Form I-766)',
        FOREIGN_PASSPORT: 'Foreign passport or ID issued by a foreign embassy or consulate contains a photograph',
        DIPLOMA: 'High School or College diploma (including high school equivalency diplomas)',
        IDENTIFICATION_CARD: 'Identification Card Issued by the Federal, State or Local Government',
        MARRIAGE_CERTIFICATE: 'Marriage Certificate',
        MILITARY_DEPENDANT_ID_CARD: 'Military dependent\'s identification card',
        NATIVE_AMERICAN_TRIBAL_DOCUMENT: 'Native American Tribal document',
        PERMANENT_RESIDENT_CARD: 'Permanent Resident Card or Alien Registration Receipt Card (Form I-551)',
        PROPERTY_DEED_OR_TITLE: 'Property Deed or Title',
        SCHOOL_ID_CARD: 'School identification card',
        SSN: 'Social Security Card',
        US_COAST_GUARD_MARINER_CARD: 'U.S Coast Guard Merchant Mariner card',
        BIRTH_RECORD: 'U.S.Public Birth Record',
        MILITARY_CARD: 'U.S military card or draft record',
        PASSPORT: 'U.S passport or U.S passport card',
        VOTER_REGISTRATION_CARD: 'Voter registration card',
    },
};

export const COMMUNICATION_METHOD = {
    IN_PERSON: 'In Person',
    TELEPHONE: 'Over Phone',
};

export const APPLICATION_STATUS_KEY = {
    CC: 'CANCELLED',
    CL: 'CLOSED',
    DQ: 'DEQUEUED',
    ER: 'ELIGIBILITY_RECEIVED',
    EN: 'ENROLLED_OR_ACTIVE',
    PN: 'PARTIALLY_ENROLLED',
    OP: 'OPEN',
    QU: 'QUEUED',
    SG: 'SIGNED',
    SU: 'SUBMITTED',
    UC: 'UNCLAIMED',
};

export const EDE_SEARCH_RESULTS_TYPE = {
    ONE_MATCH_FOUND_NOT_DESIGNATED: 'ONE_MATCH_FOUND_NOT_DESIGNATED',
    ONE_MATCH_FOUND_NOT_PRIMARY: 'ONE_MATCH_FOUND_NOT_PRIMARY',
    ONE_MATCH_FOUND_DESIGNATED_TO_OTHER_BROKER: 'ONE_MATCH_FOUND_DESIGNATED_TO_OTHER_BROKER',
    ONE_MATCH_FOUND_DESIGNATED_TO_OTHER_ASSISTER: 'ONE_MATCH_FOUND_DESIGNATED_TO_OTHER_ASSISTER',
    ONE_MATCH_FOUND_DESIGNATED_TO_OTHER_BROKER_TIED_TO_PARTNER:
        'ONE_MATCH_FOUND_DESIGNATED_TO_OTHER_BROKER_TIED_TO_PARTNER',
    ONE_MATCH_FOUND_NOT_DESIGNATED_TIED_TO_PARTNER: 'ONE_MATCH_FOUND_NOT_DESIGNATED_TIED_TO_PARTNER',
    ONE_MATCH_FOUND_DESIGNATED_TO_ASSISTER: 'ONE_MATCH_FOUND_DESIGNATED_TO_ASSISTER',
    ONE_MATCH_FOUND_DESIGNATED_TO_BROKER: 'ONE_MATCH_FOUND_DESIGNATED_TO_BROKER',
    ONE_MATCH_FOUND_DESIGNATED_TO_SAME_BROKER: 'ONE_MATCH_FOUND_DESIGNATED_TO_SAME_BROKER',
    ONE_MATCH_FOUND_DESIGNATED_TO_SAME_ASSISTER: 'ONE_MATCH_FOUND_DESIGNATED_TO_SAME_ASSISTER',
    MULTIPLE_MATCHES_FOUND: 'MULTIPLE_MATCHES_FOUND',
    NO_MATCH_FOUND: 'NO_MATCH_FOUND',
    FAILURE: 'FAILURE',
};
